import { fetchMutation } from "../../../../../actions";
import { errorToDisplay } from "../../../../../helper/CommonFuncs";
import { ShowAlert } from "../../../../newCreateContent/CreateContentAlert";
import { SEND_NOTES } from "../../../actions/shareNotesAct";

export const filterValues = (arr1, arr2, isCode = "code") => {
    if (arr1 === null) return null
    const val = isCode ? "code" : "order"
    const set2 = new Set(arr2); // O(n)
    return arr1.filter(item => set2.has(item[val])).map(({ __typename, ...rest }) => rest);
}
export const shareCodes = (obj) => {
    const { noteId, codesOrdersData, email, sucess = () => { }, errorApi = () => { } } = obj
    const { codesOrdersData: codesData } = codesOrdersData
    const isCode = codesOrdersData.isCode
    const selected = codesOrdersData.selectedCodes
    const clinicalData = {}
    if (isCode) {
        clinicalData.codes = {
            "CPT": isCode ? filterValues(codesData.CPT, selected) : null,
            "ICD": isCode ? filterValues(codesData.ICD, selected) : null
        }
    }
    else {
        clinicalData.orders = {
            "medicationOrders": isCode ? null : filterValues(codesData.medicationOrders, selected, isCode),
            "testOrders": isCode ? null : filterValues(codesData.testOrders, selected, isCode)
        }
    }


    const shareNotePayload = {
        createShareNote: {
            noteId: noteId,
            sharingTo: [
                {
                    externalShare: { dob: null, email, mobileNo: null, name: null },
                    groupId: null,
                    userId: null,
                },
            ],
            "clinicalData": clinicalData,
        },
    };

    fetchMutation(
        SEND_NOTES,
        shareNotePayload,
        (response) => {
            // ShowAlert(response.data.addSharingNoteDetails.status.message)
            sucess()
        },
        (error) => {
            ShowAlert(errorToDisplay(error), "error");
            errorApi()

        }
    );
};
export const truncateEmailFromMiddle = (email) => {
    if (email.length > 30) return email.slice(0, 15) + "..." + email.slice(-15)
    else return email

}